import React, { useState } from 'react';
import { Menu, X, Phone, Sparkles } from 'lucide-react';
import { site } from '../data/site';
const links = [{
  href: '#services',
  label: 'Services'
}, {
  href: '#process',
  label: 'How it works'
}, {
  href: '#reviews',
  label: 'Reviews'
}, {
  href: '#faq',
  label: 'FAQ'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b-4 border-[#0B1B2B] bg-[#FFFDF6]" data-id="element-91" data-mp="1fzp3ewem4a3w">
      <nav aria-label="Main" className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-5 py-4 sm:px-8" data-id="element-92" data-mp="1fxus89t57wd0">
        <a href="#top" className="flex items-center gap-2.5" data-id="element-93" data-mp="1pqjq21vrtbpv">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#0B1B2B] text-[#FFD84D]" data-id="element-94" data-mp="1uolihdf36ne0">
            <Sparkles className="h-5 w-5" aria-hidden="true" data-id="element-95" data-mp="1yqoymfcpag5m" />
          </span>
          <span className="text-lg font-extrabold leading-none tracking-tight text-[#0B1B2B]" data-id="element-96" data-mp="23p9njimi5der">
            Horizons
            <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-[#0B1B2B]/60" data-id="element-97" data-mp="1y5os9k9rqnj4">
              Window Cleaning
            </span>
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-98" data-mp="1p58tup7vu6l4">
          {links.map(link => <li key={link.href} data-id="element-99" data-mp="1p73fk5qza2q9">
              <a href={link.href} className="text-sm font-bold text-[#0B1B2B] underline-offset-8 transition hover:underline" data-id="element-100" data-mp="1k6yyadi8x3yz">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-101" data-mp="2cx789i2moi2h">
          <a href={`tel:${site.phone.replace(/[^0-9]/g, '')}`} className="flex items-center gap-2 text-sm font-bold text-[#0B1B2B]" data-id="element-102" data-mp="282tipwand55q">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="30kxj5n8lzhp3" />
            {site.phone}
          </a>
          <a href="#quote" className="rounded-full border-2 border-[#0B1B2B] bg-[#FFD84D] px-5 py-2.5 text-sm font-extrabold text-[#0B1B2B] shadow-[3px_3px_0_0_#0B1B2B] transition hover:-translate-y-0.5 hover:shadow-[5px_5px_0_0_#0B1B2B]" data-id="element-104" data-mp="2vt73r2ute3qt">
            Free quote
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-xl border-2 border-[#0B1B2B] text-[#0B1B2B] lg:hidden" data-id="element-105" data-mp="k5kdb36f20yp">
          {open ? <X className="h-5 w-5" data-id="element-106" data-mp="17hkedaqzjvm" /> : <Menu className="h-5 w-5" data-id="element-107" data-mp="189gdp89bjmf" />}
        </button>
      </nav>

      {open && <div id="mobile-menu" className="border-t-2 border-[#0B1B2B]/10 bg-[#FFFDF6] lg:hidden" data-id="element-108" data-mp="662j28acpvhy">
          <ul className="mx-auto flex w-full max-w-7xl flex-col gap-1 px-5 py-4 sm:px-8" data-id="element-109" data-mp="1vkz943mw2ms8">
            {links.map(link => <li key={link.href} data-id="element-110" data-mp="20jkaw7hsheis">
                <a href={link.href} onClick={() => setOpen(false)} className="block rounded-lg px-2 py-3 text-base font-bold text-[#0B1B2B] hover:bg-[#0B1B2B]/5" data-id="element-111" data-mp="20iix3v9e2dxd">
                  {link.label}
                </a>
              </li>)}
            <li className="mt-2" data-id="element-112" data-mp="2eq5fpmarv42w">
              <a href="#quote" onClick={() => setOpen(false)} className="block rounded-full border-2 border-[#0B1B2B] bg-[#FFD84D] px-5 py-3 text-center text-base font-extrabold text-[#0B1B2B]" data-id="element-113" data-mp="2epvs25d7990d">
                Get a free quote
              </a>
            </li>
          </ul>
        </div>}
    </header>;
}